const projectsData = [
    {
      id: 1,
      title: "> Todo List",
      description: "Aesthetic, user-friendly task manager that seamlessly syncs with a backend database to ensure your to-dos are always up-to-date.",
      technologies: "HTML, CSS, Javascript, Node/Express.js, MySQL",
      imageUrl: "./todo-list.png",
      videoUrl: "https://www.loom.com/embed/53a01246c5384537bd74809f7d3b849f?sid=825d9481-f62c-449d-af62-673680fbc499",
      githubUrl: "https://github.com/laraflopes/todolist-project",
    },

    {
      id: 2,
      title: "> Stock Options Project",
      description: "App that fetches stock options contracts for a given underlying ticker from an API, intelligently utilizing a database for efficient data retrieval when requests have been previously made.",
      technologies:"React, HTML, CSS, Javascript, Node/Express.js, MySQL, API",
      imageUrl: "./options-project1.png",
      videoUrl: "https://www.loom.com/embed/7527cd756f1e44358168ea1242d1471f?sid=13413ed3-f061-461a-a431-f574ff8c5114",
      githubUrl: "https://github.com/laraflopes/options-project"
    },

    {
      id: 3,
      title: "> Band Name Generator",
      description: "A simple tool for generating unique and creative band names instantly.",
      technologies: "HTML, CSS, Node/Express.js",
      imageUrl: "./band-generator1.png",
      videoUrl: "https://www.loom.com/embed/eeaeb6bef0dd4b58a7c71d64deff040b?sid=940b5a02-308b-4382-b84a-4d5f8ff0779c",
      githubUrl: "https://github.com/laraflopes/band-name-generator"
    },

    {
      id: 4,
      title: "> First Portfolio",
      description: "Initial Portfolio Showcase: Demonstrates foundational web development skills and personal projects in a simple, user-friendly format.",
      technologies: "HTML, CSS, Javascript",
      imageUrl: "./portfolio.png",
      githubUrl: "https://github.com/laraflopes/portfolio",
      websiteUrl: "https://laraflopes.github.io/portfolio/"
    },

    {
      id: 5,
      title: "> MoveIt",
      description: "Moving Services Website",
      technologies: "HTML, CSS, Bootstrap",
      imageUrl: "./moveit.png",
      githubUrl: "https://github.com/laraflopes/moveit-website",
      websiteUrl: "https://laraflopes.github.io/moveit-website/"                                       
    },

    {
      id: 6,
      title: "> Tindog",
      description: "A whimsical take on a dating app concept for dogs",
      technologies: "HTML, CSS, Bootstrap",
      imageUrl: "./tindog.png",
      githubUrl: "https://github.com/laraflopes/tindog-website",
      websiteUrl: "https://laraflopes.github.io/tindog-website/"                                       
    },

  ];

  export default projectsData;